import dayjs from "dayjs";
import React, {useEffect} from "react";
import {Row, Table} from "antd";
import {formatToCurrencyType} from "helper/common";
import moment from "moment";

const getTodayString = () => {
  const day = moment().format("DD");
  const month = moment().format("MM");
  const year = moment().format("YYYY");
  const time = moment().format("HH:mm");
  return `${time} Ngày ${day} tháng ${month} năm ${year}`;
};

const serviceColumns: any = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    render: (v, r, i) => i + 1,
    width: "4%",
    align: "center",
  },
  {
    title: "Mã loại thẻ",
    key: "ma",
    dataIndex: "ma",
    align: "center",
  },
  {
    title: "Tên loại thẻ",
    key: "tenLoaiThe",
    dataIndex: "tenLoaiThe",
    align: "center",
  },
  {
    title: "Số lượng",
    key: "soLuong",
    dataIndex: "soLuong",
    align: "center",
  },
  // {
  //   title: "Dịch vụ trong thẻ",
  //   showHeader: false,
  //   key: "dichVuTrongThes",
  //   dataIndex: "dichVuTrongThes",
  //   align: "center",
  //   render: (v, r, i) => {
  //     return (
  //       <table>
  //         {v?.map((it, index) => {
  //           return <tr>{it.tenDichVu}</tr>
  //         })}
  //       </table>
  //     );
  //   },
  //   style: {
  //     padding: 0
  //   }
  // },
  // {
  //   title: "Số lượng dịch vụ",
  //   key: "dichVuTrongThes",
  //   dataIndex: "dichVuTrongThes",
  //   align: "center",
  //   render: (v, r, i) => {
  //     return (
  //       <table >
  //         {v?.map((it, index) => {
  //           return <tr>{it.soLan}</tr>
  //         })}
  //       </table>
  //     );
  //   }
  // },
  {
    title: "Thời hạn",
    key: "thoiHan",
    dataIndex: "thoiHan",
    align: "center",
    render: (v, r, i) => (v === 0 ? `Vĩnh viễn` : `${v} tháng`),
  },
  {
    title: "Giá thẻ",
    dataIndex: "giaBan",
    render: (v, r, i) => formatToCurrencyType(v),
  },
];
const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export {serviceColumns, getTodayString, capitalize};
